import React from 'react'
import { Modal } from '@/shared/ui/Modal'
import { Button } from '@/shared/ui'
import { PasswordWithConfirm } from '@/shared/ui'
import type { Customer } from '../types'
import { resetAccountOwnerPassword } from '../services/customerAdminService'

type Props = {
  open: boolean
  onOpenChange: (v: boolean) => void
  customer: Customer | null
  onSaved?: () => void
}

export default function CustomerPasswordModal({ open, onOpenChange, customer, onSaved }: Props) {
  const [password, setPassword] = React.useState('')
  const [confirm, setConfirm] = React.useState('')
  const [error, setError] = React.useState<string | null>(null)
  const [saving, setSaving] = React.useState(false)

  React.useEffect(() => {
    if (!open) { setPassword(''); setConfirm(''); setError(null) }
  }, [open])

  const valid = password.length >= 8 && confirm === password && /[A-Z]/.test(password) && /[^A-Za-z0-9]/.test(password)

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!customer) return
    setError(null)
    try {
      if (!valid) throw new Error('Verifique os requisitos da senha e a confirmação')
      setSaving(true)
      await resetAccountOwnerPassword(customer.id, password, true)
      onOpenChange(false)
      onSaved?.()
    } catch (e: any) {
      setError(e?.message || 'Falha ao alterar senha')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <form className="space-y-4" onSubmit={onSubmit}>
        <div className="text-lg font-semibold">Alterar senha do cliente</div>
        <div className="text-sm text-foreground/70">Defina uma nova senha para o titular da conta. O sistema exigirá que o cliente a altere no próximo acesso.</div>
        {error && (
          <div className="rounded-md border border-destructive/30 bg-destructive/10 p-2 text-sm text-destructive-foreground">{error}</div>
        )}
        <PasswordWithConfirm
          password={password}
          confirm={confirm}
          onChange={(p)=> { setPassword(p.password ?? password); setConfirm(p.confirm ?? confirm) }}
          required
        />
        <div className="flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={saving}>Cancelar</Button>
          <Button type="submit" disabled={!valid || saving}>{saving ? 'Aplicando...' : 'Aplicar'}</Button>
        </div>
      </form>
    </Modal>
  )
}

